import { createContext, useContext } from 'react';

export interface SlideOutControls {
    open: () => void;
    close: () => void;
    toggle: () => void;
    isOpen: boolean;
}

export const SlideOutContext = createContext<SlideOutControls | undefined>(
    undefined
);

export const useSlideOutContext = (): SlideOutControls | undefined => {
    return useContext(SlideOutContext);
};
